import React, { type FC } from "react";
import useIntegratedCompare from "../../hooks/useIntegratedCompare";
import CompareLexus from "./CompareLexus";
import { NcCompareContext } from "../../../../common-deprecated/types/NewCarCompareTypes";

type PropsType = {
    mode?: NcCompareContext;
};
const IntegratedCompareLexus: FC<PropsType> = ({ mode = NcCompareContext.Original }) => {
    const { fetching } = useIntegratedCompare(mode);

    return fetching ? null : <CompareLexus />;
};

export default IntegratedCompareLexus;
